import { render, staticRenderFns } from "./LoansDetails.vue?vue&type=template&id=958d9310"
import script from "./LoansDetails.vue?vue&type=script&lang=js"
export * from "./LoansDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports